export enum LocalStorageKeysEnum {
  TOKEN = 'token',
  ID = 'id',
  ROLE = 'role',
}

export enum ApiUrlEnum {
  USER_AUTH = '/user/auth',
  USER_LOGOOUT = '/user/logout',
  USER_INIT = '/init',
  ALL_MODELS = '/view_models',
  ADD_IMAGES = '/fs/upload',
  DELETE_IMAGES = '/fs/files',
  USERS = '/users',
  USERS_CURRENT = '/users/current',
  HISTORY_INPUTS = '/history-inputs',
  RUN = '/run',
  JOURNAL = '/audits',
  JOURNAL_METHODS = '/details',
}

export enum FilterPageEnum {
  PER_PAGE = 'per_page',
  PAGE = 'page',
  SORT = 'sort',
  NAME = 'name',
  DESC = 'desc',
  USERNAME = 'username',
}

export enum SortDatePageEnum {
  UPDATE_AT = 'updated_at',
  LAST_RUN_AT = 'last_run_at',
}

export enum SortModalEnum {
  ICON_UN = 'icon_un',
  ICON_UP = 'icon_up',
  ICON_DOWN = 'icon_down',
}

export enum EitTabsModalEnum {
  MODEL = 'model',
  USER = 'user',
}

export enum InitTypeModalEnum {
  ANY_LOGIC = 1,
  VALTRON = 2,
}

export enum InitRoleEnum {
  ADMIN = 'force_logic_admin',
  MODERATOR = 'force_logic_moderator',
  USER = 'force_logic_user',
  ALL_ROLE = 'allRole',
}

export enum DroppableUserEnum {
  ALL_USER = 'allUser',
  MODELS_USER = 'modelsUser',
}

export enum RoleEnum {
  ADMIN = 'admin',
  MODERATOR = 'moderator',
  USER = 'user',
  SECURITY = 'security',
}

export enum HeaderIdEnum {
  MY_MODEL = 'myModel',
  ALL_MODEL = 'allModel',
  ADMINISTRATION = 'administration',
  JOURNAL = 'journal',
}

export enum AnyLogicTypeEnum {
  STRING = 'STRING',
  DATE_TIME = 'DATE_TIME',
}

export const enum StatusInformerEnum {
  Success = 'success',
  System = 'system',
  Alert = 'alert',
  Warning = 'warning',
}

export enum DirectoryInfoEnum {
  iconFieldNone = 'none',
}

export enum TitleForColumnsTableEnum {
  Ip = 'IP-адрес',
  DateTime = 'Дата / время',
  Login = 'Логин',
  FullName = 'ФИО',
  Role = 'Роль',
  Event = 'Действие',
  Manual = 'Инструкция по использованию',
  Description = 'Описание',
  URL = 'URL',
  Model_type = 'Тип модели',
  Name = 'Наименование модели',
  Service = 'Сервис',
  eventDate = 'Дата события',
}

export enum AccessorForTablesEnum {
  Ip = 'ip_address',
  DateEvent = 'created_at',
  Login = 'login',
  FullName = 'fullname',
  Role = 'roles',
  Event = 'method',
  Username = 'username',
  Service = 'service',
}

export enum TitleForColumnsAdministrationTableEnum {
  Fio = 'ФИО',
  Username = 'Логин',
  RoleName = 'Роль',
  NumberAvailableModels = 'Доступные модели',
}

export enum AccessorForAdministartionTablesEnum {
  Fio = 'fio',
  Username = 'username',
  RoleName = 'role_name',
  NumberAvailableModels = 'number_available_models',
}

export const backendFieldsNames: { [key: string]: string } = {
  ip_address: TitleForColumnsTableEnum.Ip,
  created_at: TitleForColumnsTableEnum.DateTime,
  login: TitleForColumnsTableEnum.Login,
  fullname: TitleForColumnsTableEnum.FullName,
  role: TitleForColumnsTableEnum.Role,
  method: TitleForColumnsTableEnum.Event,
  manual: TitleForColumnsTableEnum.Manual,
  description: TitleForColumnsTableEnum.Description,
  service_url: TitleForColumnsTableEnum.URL,
  model_type: TitleForColumnsTableEnum.Model_type,
  name: TitleForColumnsTableEnum.Name,
};

export enum journalMethodsNamesEnum {
  UpdateEntry = 'Обновление записи',
  DeleteEntries = 'Удаление записей',
  Export = 'Выгрузка excel',
  ExportTesting = 'Выгрузка списка на тестирование',
  ExportAnylitic = 'Выгрузка отчетности по основной аналитике',
  ExportAnyliticAdditional = 'Выгрузка отчетности по дополнительной аналитике',
  AddEntry = 'Добавление записи',
  Import = 'Загрузка excel',
  ImportFile = 'Загрузка файла',
  Auth = 'Авторизация',
  Logout = 'Выход из системы',
  ResetPass = 'Сброс пароля на стандартный',
  ChangePass = 'Смена пароля пользователем',
  CreateUser = 'Создание пользователя',
  DeleteUser = 'Удаление пользователя',
  BlockedUser = 'Блокировка/Разблокировка пользователя',
  UserBlock = 'Блокировка пользователя',
  UserUnBlock = 'Разблокировка пользователя',
  EditUser = 'Редактирование пользователя',
  DeleteFile = 'Удаление файла',
  CreateSubdiv = 'Создание подразделения',
  UpdateSubdiv = 'Редактирование подразделения',
  DeleteSubdiv = 'Удаление подразделения',
  DeleteEntry = 'Удаление записи',
  AddFilesEmployee = 'Добавление файлов сотруднику',
  runModel = 'Запуск модели',
  putModel = 'Изменение модели',
  createModel = 'Создание модели',
  deleteModel = 'Удаление модели',
  editHistoryInputs = 'Изменение параметров запуска модели',
}

// export const journalMethodsNames: { [key: string]: string } = {
//   'keyclock.login': journalMethodsNamesEnum.Auth,
//   'staff.staff:put': journalMethodsNamesEnum.UpdateEntry,
//   'staff.staffs:delete': journalMethodsNamesEnum.DeleteEntries,
//   'staff.export:export': journalMethodsNamesEnum.Export,
//   'staff.testing_export:export': journalMethodsNamesEnum.ExportTesting,
//   'staff.staffs:post': journalMethodsNamesEnum.AddEntry,
//   'staff.import:import': journalMethodsNamesEnum.Import,
//   'fs.upload:post': journalMethodsNamesEnum.ImportFile,
//   'staff.upload_file:post': journalMethodsNamesEnum.ImportFile,
//   'user.logout:logout': journalMethodsNamesEnum.Logout,
//   'user.user_password_reset:post': journalMethodsNamesEnum.ResetPass,
//   'user.users:post': journalMethodsNamesEnum.CreateUser,
//   'user.user:delete': journalMethodsNamesEnum.DeleteUser,
//   'user.user_blocked:post': journalMethodsNamesEnum.BlockedUser,
//   'user.user:put': journalMethodsNamesEnum.EditUser,
//   'fs.file_del:delete': journalMethodsNamesEnum.DeleteFile,
//   'division.divisions:post': journalMethodsNamesEnum.CreateSubdiv,
//   'division.division:delete': journalMethodsNamesEnum.DeleteSubdiv,
//   'division.division:put': journalMethodsNamesEnum.UpdateSubdiv,
//   'staff.staff:delete': journalMethodsNamesEnum.DeleteEntry,
//   'user.user_password_edit:post': journalMethodsNamesEnum.ChangePass,
//   'staff.add_files:post': journalMethodsNamesEnum.AddFilesEmployee,
//   'analytic.analytic_additional_export:export':
//     journalMethodsNamesEnum.ExportAnyliticAdditional,
//   'analytic.analytic_export:export': journalMethodsNamesEnum.ExportAnylitic,
//   'fs.file_del:put': journalMethodsNamesEnum.UpdateEntry,
//   'view_models.run_model:post': journalMethodsNamesEnum.runModel,
//   'view_models.view_model:put': journalMethodsNamesEnum.putModel,
//   'view_models.history_inputs:post': journalMethodsNamesEnum.editHistoryInputs,
//   'view_models.view_model:delete': journalMethodsNamesEnum.deleteModel,
//   'view_models.view_models:post': journalMethodsNamesEnum.createModel,
// };

export enum JournalMethodsEnum {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  INSERT = 'INSERT',
  APPEND = 'APPEND',
  BULK_REPLACE = 'BULK_REPLACE',
  SELECT = 'SELECT',
}

export enum TextViewEnum {
  LINK = 'link',
  ALERT = 'alert',
  PRIMARY = 'primary',
  BRAND = 'brand',
  GHOST = 'ghost',
  LINK_MINOR = 'linkMinor',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  WARNING = 'warning',
}
